import React from 'react';
import PropTypes from 'prop-types';

import DialogWithWarningLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithWarningLayout';

export default function AlertIdNotFoundDialog (props) {
  return (
    <DialogWithWarningLayout
      {...props}
      className="alert-id-not-found-dialog"
      size='md'
      character={'!'}
      header={'The alert cannot be found.'}
      footerClassName={'no-border'}
    >
      Please confirm that you are the owner of the alert. Only the alert owner is able to view and edit an alert that they have created.
    </DialogWithWarningLayout>
  );
}

AlertIdNotFoundDialog.propTypes = {};
